import * as z from "zod/v4";

export const reconnectFaireIntegration = {
  name: "reconnectFaireIntegration" as const,
  input: z.object({}),
  output: z.object({ success: z.boolean() }),
};
